import { api } from "./api";
import i18n from "./i18n";

const session = Math.random().toString(36).slice(2, 12);

export function track(type, extra = {}) {
  const region = (navigator.language || "").split("-")[1];
  api
    .post("/analytics/event", {
      type,
      path: window.location.pathname,
      lang: i18n.language,
      region: region && region.length === 2 ? region : undefined,
      session,
      ...extra,
    })
    .catch(() => {});
}
